import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";

export default function InvestorPools({ lang = {} }) {
  const [pools, setPools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const session = JSON.parse(sessionStorage.getItem("aman-investor") || "{}");
    const token = session.token;
    if (!token) return;

    axios
      .get(`${apiKey}/investor-panel/pools`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setPools(res.data.pools || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid px-4 py-3">
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Pools || "Investment Pools & Reports"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item active">Investment Pools</li>
          </ol>
        </nav>
      </div>

      <div className="row g-4">
        {loading ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : pools.length === 0 ? (
          <div className="col-12">
            <div className="card shadow-sm border-0 rounded-3 p-4 text-center text-muted">
              No active investment pools to display.
            </div>
          </div>
        ) : (
          pools.map((pool) => (
            <div className="col-md-6 col-lg-4" key={pool.id}>
              <div className="card shadow-sm border-0 rounded-4 h-100">
                <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                  <h6 className="fw-bold m-0 text-primary">{pool.pool_name || `Pool #${pool.id}`}</h6>
                  <span className="badge bg-success">Active</span>
                </div>
                <div className="card-body p-4">
                  <div className="mb-3">
                    <span className="small text-muted d-block">Pool Target / Value:</span>
                    <h4 className="fw-bold text-dark mb-0">
                      SAR {pool.total_value ? Number(pool.total_value).toLocaleString() : "N/A"}
                    </h4>
                  </div>

                  <div className="mb-3">
                    <span className="small text-muted d-block">Profit Rate / Ratio:</span>
                    <strong className="text-success">{pool.profit_ratio || pool.profit_rate || "N/A"}%</strong>
                  </div>

                  <div className="mb-3">
                    <span className="small text-muted d-block">Description / Details:</span>
                    <p className="small text-secondary mb-0">{pool.description || "Investment pool managed by office."}</p>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
